const Scroll = require('./scroll');

/**
 * Anchor
 * @class
 */
class Anchor {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      animeOpts: {
        duration: 600,
        easing  : 'easeOutQuad',
        offset  : 0,
      }
    }
  }

  /**
   * @instance
   * @param el {HTMLElement} element
   * @param opts {object} options
   */
  constructor(el, opts = {}) {
    const { animeOpts } = _.defaultsDeep(opts, Anchor.defOpts);

    const href = el.getAttribute('href');
    if(!href) return;
    if(!href.match(/^#/)) return;

    this.scroll = new Scroll(el, animeOpts);

    el.addEventListener('click', this.onClicked.bind(this), false);
  }

  /**
   * @instance
   * @private
   * @param e {event}
   */
  onClicked(e) {
    const href = e.currentTarget.getAttribute('href');

    if(!href) return;
    e.preventDefault();

    const target = (href === '#') ? 'html, body' : href;
    this.scroll.run(document.querySelectorAll(target));
  }

}

/**
 * class exports
 */
module.exports = Anchor;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/anchor.js
 **/